/*export const StealthUpgrades = [
  { name: "TODO", cost: 0, heat: 0, launder: 0 },
  { name: "TODO", cost: 3, heat: -1, launder: 0 },
  { name: "TODO", cost: 10, heat: -3, launder: 0 },
  { name: "TODO", cost: 10, heat: -9, launder: 0 },
];*/

/*export const RevenueUpgrades = [
  { name: "TODO", cost: 0, heat: 0, launder: 0 },
  { name: "Unlicensed lemonade stand", cost: 1, heat: 2, launder: 0 },
  { name: "TODO", cost: 1, heat: 2, launder: 0 },
  { name: "TODO", cost: 1, heat: 2, launder: 0 },
];*/

export const LaunderUpgrades = [
  { name: "None", cost: 0, rate: 0, heat: 1.0 },
  { name: "Lemonade Stand", cost: 5000, rate: 0.25, heat: 1.0 },
  { name: "Car Wash", cost: 50000, rate: 1, heat: 1.0 },
  { name: "Casino", cost: 100000, rate: 10, heat: 1.0 },
  { name: "Bank", cost: 500000, rate: 50, heat: 1.0 },
  { name: "Fed Reserve", cost: 1000000, rate: 500, heat: 1.0 },
];
